import { useCallback, useContext } from 'react';
import { ProductTableContext } from '../../../contexts/product-table-context';
import type { Filters } from '../../../hooks/products';
import { Checkbox } from '../../forms';
import { withFilterField } from './filter-component';
import { FilterWrapper } from './filter-wrapper';

export const HideDisabledFilter = withFilterField('hideDisabled', function HideDisabledFilter() {
  const { filters, setFilters } = useContext(ProductTableContext);
  const { hideDisabled } = filters;

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setFilters((prev: Filters) => ({ ...prev, hideDisabled: event.target.checked }));
    },
    [setFilters]
  );

  return (
    <FilterWrapper label="Hide Disabled">
      <Checkbox invalid={false} checked={hideDisabled === true} onChange={onChange} />
    </FilterWrapper>
  );
});
